import type { Order } from '@trmediaab/zebra-types/trhub';
import { useEffect } from 'react';
import { subscribe } from 'valtio';

import { useMutatableState } from '.';

export type OrderChangeCallback = (
  orderChanges: Parameters<Parameters<typeof subscribe>[1]>[0],
  order: Order,
) => void;

export default function useOrderSubscription(callback: OrderChangeCallback) {
  const state = useMutatableState();

  useEffect(
    () =>
      // We must subscribe to the whole state to catch all changes
      // if we just subscribe to state.order a quantity-change wont trigger
      subscribe(state, changes => {
        // Filter out changes to the order object
        const orderChanges = changes.filter(([, path]) => path[0] === 'order');
        if (orderChanges.length > 0) {
          callback(orderChanges, state.order as Order);
        }
      }),
    [callback, state],
  );
}
